export function disableApprover(arr: boolean[]) {
  return arr.every((x: boolean) => !x);
}
